import(/* webpackMode: "eager" */ "/home/ubuntu/actions-runner-4/_work/yardzen/yardzen/apps/build-marketplace/app/(default)/design-project/page.tsx");
